import { IconComponent } from '../icon.types';

export const DropdownIcon: IconComponent = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M3 6L8 10L13 6" stroke="currentColor" strokeWidth="2" />
  </svg>
);
